import app from '../app';
import Component from '../../common/Component';
import Button from '../../common/components/Button';
import SelectDropdown from '../../common/components/SelectDropdown';
import ItemList from '../../common/utils/ItemList';
import listItems from '../../common/helpers/listItems';
import Search from '../components/Search';

/**
 * The `HeaderSecondary` component displays secondary header controls, such as
 * the search box and the user menu. On the default skin, these are shown on the
 * right side of the header.
 */
export default class HeaderTitle extends Component {
  view() {
    let pkgLogo = app.data.pkgLogo;
    // 将字符串映射转换为 JavaScript 对象
    const obj = JSON.parse(pkgLogo.pkgLogo);
    // 创建 Map 对象并初始化
    const map = new Map(Object.entries(obj));
    // 获取特定键的值
    let localePkgLogo = map.get(app.data.locale);
    return <div class="Header-title-lin" id="home-link">
            <img  src={localePkgLogo} />
            {/* {app.translator.trans('dl-index.forum.official_forum')} */}
          </div>;
  }

}
